import React, { useState } from 'react';
import  { useFetchShareHouse } from '../../hooks/useFetchData';
import List from '../../components/shared/List';
import MainLayout from '../../components/layouts/MainLayout';
import Breadcrumb from '../../components/shared/Breadcrumbs';

const ShareHousePage = () => {
  const [formData, setFormData] = useState([]);
  const { data: sharehouses, loading, error } = useFetchShareHouse(formData); 
  // const [showButtons, setShowButtons] = useState();

  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "シェアハウス一覧", path: "/sharehouse" },
  ];


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading jobs: {error.message}</p>;

  const formConfig1 = {
    fields:[
    { name: 'room', type: 'checkbox', label: '部屋タイプ', category: 'room', initialValue: '' },
    { name: 'gender', type: 'checkbox', label: '性別', category: 'gender', initialValue: '' },
    { name: 'couple', type: 'checkbox', label: 'カップル', category: 'couple', initialValue: '' },
    { name: 'equipment', type: 'checkbox', label: 'こだわり項目', category: 'equipment', initialValue: '' },
  ],
  }
  const formConfig2 = {
    fields:[
    { name: 'sorting', type: 'radio', label: '並べ替え', category: 'sorting', initialValue: '' },
    ]
  }

  return (
    <MainLayout>
      <Breadcrumb items={breadcrumbs} />
      <div>
        <List 
          items={sharehouses} 
          title="Share House" 
          subtitle="シェアハウス掲示板" 
          showButtons={true} 
          type="sharehouse"
          formConfig1={formConfig1}
          formConfig2={formConfig2}
          setFormData={setFormData}
          formData={formData}
        />
      </div>
    </MainLayout>
  );
};

export default ShareHousePage;